import request from '../utils/request';
import { buildApiPayload } from '../utils/api';
import baseApi from './baseApi';

export function getTimersCycleHistory(params, signal) {
  return request({
    url: '/timerCycleHistory',
    method: 'get',
    data: buildApiPayload({ payload: params, dateEndKeys: ['endTime'] }),
    signal,
  });
}

export function getTimersCycleHistoryTotal(params, signal) {
  return request({
    url: '/timerCycleHistory/total',
    method: 'get',
    data: buildApiPayload({ payload: params, dateEndKeys: ['endTime'] }),
    signal,
  });
}

export function getExelExport(params) {
  return request({
    url: '/timerCycleHistory/xls',
    method: 'get',
    data: buildApiPayload({ payload: params, dateEndKeys: ['endTime'] }),
    responseType: 'arraybuffer',
  });
}

export function deleteTimer(uuid) {
  return request({
    url: `/timerCycleHistory/${uuid}`,
    method: 'delete',
  });
}

const timerCycleHistoryApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    bulkDeleteHotHoldingTCHs: builder.mutation({
      query: ({ uuids }) => ({
        url: '/timerCycleHistory',
        method: 'DELETE',
        data: {
          uuids,
        },
      }),
    }),
  }),
});

export const {
  useBulkDeleteHotHoldingTCHsMutation: useBulkDeleteHotHoldingTCHs,
} = timerCycleHistoryApi;

export default timerCycleHistoryApi;
